// extracted by css-extract-rspack-plugin
export default {"checkboxInput":"checkboxInput-3vKEn","label":"label-vXgIe","labelText":"labelText-eW4YD"};